import React from "react"
import AppCalendarAlertsDrawer from "./Alerts"
import AppCalendarEventCreationModal from "./EventCreation";


export default function AppCalendarModals() {


    return <>
        <AppCalendarAlertsDrawer />
        <AppCalendarEventCreationModal />
    </>
}